// Package Imports
import axios from "axios";
import { toJS } from "mobx";

// Project Imports
import * as APITypes from "constants/API";
import AuthStore from "modules/login/store/AuthStore";
import OptimizationStore from "../../store/OptimizationStore";
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import updateProductwiseRiskData from "../updateProductwiseRiskData";
import generateChangeProposerDataStructure from "./generateChangeProposerDataStructure";
import fetchNeedDetailsBasedonNeedUniqueName from "utils/fetchNeedDetailsBasedonNeedUniqueName";
import { API_DELAY_TIME } from "constants/Constants";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../constants/Constants";

const changeProposerApiCall = async () => {
  let selectedNeed = await fetchNeedDetailsBasedonNeedUniqueName(
    OptimizationStore.changeProposerDetails.needUniqueName
  );
  const journeyData = toJS(AuthStore.journeyData);
  let { journey_details } = journeyData;

  let productId = "";
  if (Array.isArray(OptimizationStore.selectedNeedCardData.BI)) {
    let riskProductData = OptimizationStore.selectedNeedCardData.BI.filter(
      (item) => item.risk == OptimizationStore.selectedNeedCardData.selectedRisk
    )[0];
    productId = riskProductData.family_product_id;
  } else {
    productId = OptimizationStore.selectedNeedCardData.family_product_id;
  }
  const changeProposerRequestObj = {
    proposer_id: OptimizationStore.selectedFamilyMemberId,
    family_product_id: productId,
    need: selectedNeed.id,
    journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    is_selected: true,
  };

  OptimizationStore.setFamilyMemberModalType(undefined);
  generateChangeProposerDataStructure(changeProposerRequestObj, selectedNeed);

  let requestList = [];
  let riskList = [];

  if (selectedNeed.unique_name !== NeedTypeEnum.PROTECTION_FOR_MY_FAMILY) {
    if (journey_details.high_risk_selected) {
      riskList.push("high");
    }
    riskList = [...riskList, ...["medium", "low"]];
    riskList.forEach((item) => {
      requestList.push({...changeProposerRequestObj, risk_type: item });
    });
  } else {
    requestList.push({...changeProposerRequestObj, risk_type: "high" });
  }


  const promises = [];
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function makeRequests() {
    for (const item of requestList) {
      promises.push(axios.post(APITypes.CHANGE_NEW_PR, item, item));
      await delay(API_DELAY_TIME);
    }

    await Promise.all(promises.map((item) =>
      item.then((result) => updateProductwiseRiskData(result))
    ));
  }

  makeRequests()
    .then(() => {
      console.log("All requests completed");
    })
    .catch((error) => {
      console.error("Error making requests: ", error);
    });
};

export default changeProposerApiCall;
